/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/workout_request_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./workout_request_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient =
  function WorkoutRequestServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient =
  function WorkoutRequestServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListWorkoutRequestsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>}
 */
const methodDescriptor_WorkoutRequestService_ListWorkoutRequests =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequests",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.listWorkoutRequests =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequests",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ListWorkoutRequests,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.listWorkoutRequests =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequests",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ListWorkoutRequests
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetWorkoutRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_GetWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetWorkoutRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetWorkoutRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.getWorkoutRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_GetWorkoutRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.getWorkoutRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_GetWorkoutRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateWorkoutRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_CreateWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateWorkoutRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateWorkoutRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.createWorkoutRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_CreateWorkoutRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.createWorkoutRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_CreateWorkoutRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_WorkoutRequestService_DeleteWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteWorkoutRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.deleteWorkoutRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_DeleteWorkoutRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.deleteWorkoutRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_DeleteWorkoutRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>}
 */
const methodDescriptor_WorkoutRequestService_BulkQuickPassWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkQuickPassWorkoutRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.BulkQuickPassWorkoutRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.bulkQuickPassWorkoutRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkQuickPassWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_BulkQuickPassWorkoutRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkQuickPassWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.bulkQuickPassWorkoutRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkQuickPassWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_BulkQuickPassWorkoutRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_RevertQuickPassWorkoutRequestExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertQuickPassWorkoutRequestExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.RevertQuickPassWorkoutRequestExamRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.revertQuickPassWorkoutRequestExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertQuickPassWorkoutRequestExam",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_RevertQuickPassWorkoutRequestExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.RevertQuickPassWorkoutRequestExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.revertQuickPassWorkoutRequestExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertQuickPassWorkoutRequestExam",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_RevertQuickPassWorkoutRequestExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest,
 *   !proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>}
 */
const methodDescriptor_WorkoutRequestService_BulkRequireWorkoutRequestExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkRequireWorkoutRequestExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.BulkRequireWorkoutRequestExamRequest,
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.bulkRequireWorkoutRequestExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkRequireWorkoutRequestExam",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_BulkRequireWorkoutRequestExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkRequireWorkoutRequestExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.bulkRequireWorkoutRequestExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkRequireWorkoutRequestExam",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_BulkRequireWorkoutRequestExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest,
 *   !proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>}
 */
const methodDescriptor_WorkoutRequestService_BulkAssignWorkoutRequestExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkAssignWorkoutRequestExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.BulkAssignWorkoutRequestExamRequest,
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.bulkAssignWorkoutRequestExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkAssignWorkoutRequestExam",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_BulkAssignWorkoutRequestExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.BulkAssignWorkoutRequestExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.bulkAssignWorkoutRequestExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/BulkAssignWorkoutRequestExam",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_BulkAssignWorkoutRequestExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_UnassignWorkoutRequestExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/UnassignWorkoutRequestExam",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UnassignWorkoutRequestExamRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.unassignWorkoutRequestExam =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/UnassignWorkoutRequestExam",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_UnassignWorkoutRequestExam,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UnassignWorkoutRequestExamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.unassignWorkoutRequestExam =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/UnassignWorkoutRequestExam",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_UnassignWorkoutRequestExam
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_MoveFacilityWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/MoveFacilityWorkoutRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.MoveFacilityWorkoutRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.moveFacilityWorkoutRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/MoveFacilityWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_MoveFacilityWorkoutRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.MoveFacilityWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.moveFacilityWorkoutRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/MoveFacilityWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_MoveFacilityWorkoutRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CancelWorkoutRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_CancelWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/CancelWorkoutRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CancelWorkoutRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CancelWorkoutRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CancelWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.cancelWorkoutRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/CancelWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_CancelWorkoutRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CancelWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.cancelWorkoutRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/CancelWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_CancelWorkoutRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.RejectWorkoutRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_RejectWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/RejectWorkoutRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.RejectWorkoutRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.RejectWorkoutRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.RejectWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.rejectWorkoutRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/RejectWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_RejectWorkoutRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.RejectWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.rejectWorkoutRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/RejectWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_RejectWorkoutRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.RevertWorkoutRequestRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_RevertWorkoutRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertWorkoutRequest",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.RevertWorkoutRequestRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.RevertWorkoutRequestRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.RevertWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.revertWorkoutRequest =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_RevertWorkoutRequest,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.RevertWorkoutRequestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.revertWorkoutRequest =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/RevertWorkoutRequest",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_RevertWorkoutRequest
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequestComment>}
 */
const methodDescriptor_WorkoutRequestService_CreateWorkoutRequestComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequestComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateWorkoutRequestCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequestComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequestComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequestComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequestComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.createWorkoutRequestComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequestComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_CreateWorkoutRequestComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateWorkoutRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequestComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.createWorkoutRequestComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/CreateWorkoutRequestComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_CreateWorkoutRequestComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_WorkoutRequestService_DeleteWorkoutRequestComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequestComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteWorkoutRequestCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.deleteWorkoutRequestComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequestComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_DeleteWorkoutRequestComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteWorkoutRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.deleteWorkoutRequestComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/DeleteWorkoutRequestComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_DeleteWorkoutRequestComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequestComment>}
 */
const methodDescriptor_WorkoutRequestService_GetWorkoutRequestComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetWorkoutRequestCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequestComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequestComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequestComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequestComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.getWorkoutRequestComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_GetWorkoutRequestComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetWorkoutRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequestComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.getWorkoutRequestComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_GetWorkoutRequestComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse>}
 */
const methodDescriptor_WorkoutRequestService_ListWorkoutRequestComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestComments",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestCommentsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestCommentsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestCommentsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.listWorkoutRequestComments =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestComments",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ListWorkoutRequestComments,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.listWorkoutRequestComments =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestComments",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ListWorkoutRequestComments
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequestComment>}
 */
const methodDescriptor_WorkoutRequestService_EditWorkoutRequestComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/EditWorkoutRequestComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.EditWorkoutRequestCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequestComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequestComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequestComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequestComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.editWorkoutRequestComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/EditWorkoutRequestComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_EditWorkoutRequestComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.EditWorkoutRequestCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequestComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.editWorkoutRequestComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/EditWorkoutRequestComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_EditWorkoutRequestComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest,
 *   !proto.stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse>}
 */
const methodDescriptor_WorkoutRequestService_PullWorkoutRequestReport =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWorkoutRequestReport",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullWorkoutRequestReportRequest,
    stronachgroup_first_racehorse360_messages_pb.PullWorkoutRequestReportResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullWorkoutRequestReportResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.pullWorkoutRequestReport =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWorkoutRequestReport",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_PullWorkoutRequestReport,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWorkoutRequestReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullWorkoutRequestReportResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.pullWorkoutRequestReport =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWorkoutRequestReport",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_PullWorkoutRequestReport
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest,
 *   !proto.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse>}
 */
const methodDescriptor_WorkoutRequestService_PullWrongfulWorkoutReport =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWrongfulWorkoutReport",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullWrongfulWorkoutReportRequest,
    stronachgroup_first_racehorse360_messages_pb.PullWrongfulWorkoutReportResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullWrongfulWorkoutReportResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.pullWrongfulWorkoutReport =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWrongfulWorkoutReport",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_PullWrongfulWorkoutReport,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullWrongfulWorkoutReportResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.pullWrongfulWorkoutReport =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/PullWrongfulWorkoutReport",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_PullWrongfulWorkoutReport
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest,
 *   !proto.stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse>}
 */
const methodDescriptor_WorkoutRequestService_PullScheduledWorkoutReport =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/PullScheduledWorkoutReport",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullScheduledWorkoutReportRequest,
    stronachgroup_first_racehorse360_messages_pb.PullScheduledWorkoutReportResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullScheduledWorkoutReportResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.pullScheduledWorkoutReport =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/PullScheduledWorkoutReport",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_PullScheduledWorkoutReport,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullScheduledWorkoutReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullScheduledWorkoutReportResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.pullScheduledWorkoutReport =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/PullScheduledWorkoutReport",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_PullScheduledWorkoutReport
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_SetWorkoutRequestFlag =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestFlag",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SetWorkoutRequestFlagRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.setWorkoutRequestFlag =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestFlag",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_SetWorkoutRequestFlag,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetWorkoutRequestFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.setWorkoutRequestFlag =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestFlag",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_SetWorkoutRequestFlag
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_ResetWorkoutRequestFlag =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestFlag",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ResetWorkoutRequestFlagRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.resetWorkoutRequestFlag =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestFlag",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ResetWorkoutRequestFlag,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetWorkoutRequestFlagRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.resetWorkoutRequestFlag =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestFlag",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ResetWorkoutRequestFlag
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_SetWorkoutRequestExamReasonNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestExamReasonNote",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SetWorkoutRequestExamReasonNoteRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.setWorkoutRequestExamReasonNote =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestExamReasonNote",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_SetWorkoutRequestExamReasonNote,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetWorkoutRequestExamReasonNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.setWorkoutRequestExamReasonNote =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/SetWorkoutRequestExamReasonNote",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_SetWorkoutRequestExamReasonNote
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 */
const methodDescriptor_WorkoutRequestService_ResetWorkoutRequestExamReasonNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestExamReasonNote",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ResetWorkoutRequestExamReasonNoteRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequest.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.resetWorkoutRequestExamReasonNote =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestExamReasonNote",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ResetWorkoutRequestExamReasonNote,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ResetWorkoutRequestExamReasonNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequest>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.resetWorkoutRequestExamReasonNote =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ResetWorkoutRequestExamReasonNote",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ResetWorkoutRequestExamReasonNote
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment>}
 */
const methodDescriptor_WorkoutRequestService_GetWorkoutRequestRejectionComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestRejectionComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetWorkoutRequestRejectionCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequestRejectionComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.WorkoutRequestRejectionComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.getWorkoutRequestRejectionComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestRejectionComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_GetWorkoutRequestRejectionComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetWorkoutRequestRejectionCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.WorkoutRequestRejectionComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.getWorkoutRequestRejectionComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/GetWorkoutRequestRejectionComment",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_GetWorkoutRequestRejectionComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse>}
 */
const methodDescriptor_WorkoutRequestService_ListWorkoutRequestRejectionComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestRejectionComments",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestRejectionCommentsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestRejectionCommentsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListWorkoutRequestRejectionCommentsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServiceClient.prototype.listWorkoutRequestRejectionComments =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestRejectionComments",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ListWorkoutRequestRejectionComments,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListWorkoutRequestRejectionCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.WorkoutRequestServicePromiseClient.prototype.listWorkoutRequestRejectionComments =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkoutRequestService/ListWorkoutRequestRejectionComments",
      request,
      metadata || {},
      methodDescriptor_WorkoutRequestService_ListWorkoutRequestRejectionComments
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
